import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { listByOrdersProductId } from '@/api/orders-products-dispatches';
import Inr from '@/components/Inr/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.list = [];
    this.listLoading = true;
    this.rules = {
      rejectReason: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  created() {
    this.getList(this.ordersProductId);
  }
  activated() {
    this.getList(this.ordersProductId);
  }
  async getList(ordersDispatchId) {
    try {
      this.listLoading = true;
      const data = await listByOrdersProductId(ordersDispatchId);
      this.list = data;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
};
__decorate([Prop({
  default: 0
})], default_1.prototype, "ordersProductId", void 0);
default_1 = __decorate([Component({
  name: 'DispatchList',
  components: {
    Inr
  }
})], default_1);
export default default_1;